import compactDeschis from './assets/logo/elsa-compact-pe-deschis.svg';
import compactInchis from './assets/logo/elsa-compact-pe-inchis.svg';
import principalDeschis from './assets/logo/elsa-principal-pe-deschis.svg';
import principalInchis from './assets/logo/elsa-principal-pe-inchis.svg';

// Marca ELSA by WebCustom, din kitul de identitate (01-Logo). Logourile sunt fisierele SVG ale
// kitului, neschimbate: „principal” (cu „by WebCustom”) pe site, „compact” in bara aplicatiei.
// Reguli: nu se deformeaza, nu se rotesc, nu li se schimba culorile; minim 140 px latime pentru
// principal si 80 px pentru compact.

const LOGOS = {
  principal: { inchis: principalInchis, deschis: principalDeschis, ratio: 479.1 / 130 },
  compact: { inchis: compactInchis, deschis: compactDeschis, ratio: 458.85 / 113.75 },
} as const;

export function Logo({
  variant = 'compact',
  fundal = 'inchis',
  height = 28,
  className,
}: {
  variant?: keyof typeof LOGOS;
  /** Culoarea fundalului pe care sta logoul: „inchis” (negru, verde) sau „deschis” (hartie). */
  fundal?: 'inchis' | 'deschis';
  height?: number;
  className?: string;
}) {
  const l = LOGOS[variant];
  return (
    <img
      src={l[fundal]}
      alt={variant === 'principal' ? 'ELSA by WebCustom' : 'ELSA'}
      height={height}
      width={Math.round(height * l.ratio)}
      className={className}
      style={{ height, width: 'auto' }}
    />
  );
}

/**
 * Simbolul (lupa-radar), desenat inline ca sa poata lua culorile sectiunii: decor in hero,
 * semn pe fundalul rosu. `mic` = varianta de sub 24 px, fara inelul interior.
 */
export function Simbol({
  size = 32,
  inel = '#f3f2f2',
  felie = '#ec3013',
  mic = false,
  className,
}: {
  size?: number;
  inel?: string;
  felie?: string;
  mic?: boolean;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      aria-hidden="true"
      className={className}
      style={{ display: 'block', flex: 'none' }}
    >
      {mic ? (
        <>
          <circle cx="20" cy="20" r="14.5" fill="none" stroke={inel} strokeWidth="5" />
          <path d="M20 20V9A11 11 0 0 1 29.53 14.5Z" fill={felie} />
        </>
      ) : (
        <>
          <circle cx="20" cy="20" r="15" fill="none" stroke={inel} strokeWidth="4" />
          <circle cx="20" cy="20" r="7.5" fill="none" stroke={inel} strokeWidth="2" />
          <path d="M20 20V8A12 12 0 0 1 30.39 14Z" fill={felie} />
        </>
      )}
      <path d="M29.88 34.12L34.12 29.88L46 41.76V46H41.76Z" fill={inel} />
    </svg>
  );
}

/** Sageata din butoanele machetei („Solicita demo →”). */
export function Sageata() {
  return (
    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" style={{ flex: 'none' }}>
      <path d="M2 8h11M9 4l4 4-4 4" fill="none" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
